export interface BriefStep {
  id?: number;
  step_type?: string;
  question_uuid?: string;
}

export interface BriefAnswerPayloadItem {
  question_uuid: string;
  sort_order: number;
  answer: string;
}

/**
 * Build ordered answer payload for brief generation API.
 * Maps wizard answers by briefSteps index (currentStep), not Object.values order.
 */
export function buildAnswersPayload(
  briefSteps: BriefStep[],
  localAnswers: Record<number, string>,
): BriefAnswerPayloadItem[] {
  const questionSteps = briefSteps.filter(
    (s) => s.step_type === 'question' && s.question_uuid,
  );

  return questionSteps.map((step, index) => {
    const stepIndex = briefSteps.indexOf(step);
    const answer =
      (stepIndex >= 0 ? localAnswers[stepIndex] : undefined) ??
      (step.id !== undefined ? localAnswers[step.id] : undefined) ??
      '';

    return {
      question_uuid: step.question_uuid as string,
      sort_order: index + 1,
      answer: String(answer).trim(),
    };
  });
}
